/* ================================================== */
/* CARD
/* ================================================== */

function cardHeight() {
	$('.type-homepage .block.max-vh-100:not(.block-cover.w-100), body:not(.type-homepage) .block.max-vh-100').each(function(index, element) {
		if (isOverflown($(element)[0]) || ($(element).find('.text-wrapper-card').length && isOverflown($(element).find('.text-wrapper-card')[0]))) {
			$(element).removeClass('max-vh-100 vh-ratio').addClass('max-vh-100-disabled vh-ratio-disabled');
		}
	});
}

$(document).ready(cardHeight());
$(window).on('resize orientationchange', function() {
	$('.max-vh-100-disabled').removeClass('max-vh-100-disabled').addClass('max-vh-100');
	$('.vh-ratio-disabled').removeClass('vh-ratio-disabled').addClass('vh-ratio');
	cardHeight();
});